module.exports = __webpack_public_path__ + "494c1ab7263e1478eb12ce7664695834.jpg";